export default __webpack_public_path__ + "static/facade-moon-52e2f02e63689e11005b19c5559697c8.svg";